/**
 * BrainboxTools
 *
 * Standalone responder for Brainbox "system" tool calls (_System_* tools that
 * the LLM invokes). These are answered by Brainbox, not the Wavebox extension,
 * so this hook is deliberately independent of ExtensionBridge.
 *
 * The server intercepts the tool call and pipes a dedicated request down the
 * socket; this hook computes the answer in-page (where the user's real clock
 * and timezone live — the server is UTC) and pipes the result back up.
 */
const BrainboxTools = {
  mounted () {
    this.handleEvent('brainbox_get_datetime', (data) => this.getCurrentDateTime(data))
  },

  getCurrentDateTime ({ message_id, tool_use_id }) {
    const now = new Date()

    let timezone
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
    } catch {
      timezone = ''
    }

    const localDateTime = now.toLocaleString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      timeZone: timezone || undefined
    })

    this.pushEvent('brainbox_datetime_result', {
      message_id,
      tool_use_id,
      is_error: false,
      result: {
        success: true,
        localDateTime,
        isoUtc: now.toISOString(),
        timezone
      }
    })
  }
}

export default BrainboxTools
